import MemberImage from "../../assets/gg-members.png";
import GgicPng from "../../assets/ggic_1.png";
import WagmiPng from "../../assets/wagmi_1.png";
import { Interface, LandingImage } from "../../theme";

const MemberPage = (props: any) => {
	return (
		<>
			<LandingImage alt={'member-image'} src={MemberImage}></LandingImage>
			{/* <Interface>
				<img src={GgicPng} width={'250px'}></img>
				<img src={WagmiPng} width={'250px'}></img>
			</Interface> */}
		</>
	)
}
export default MemberPage
